<template>
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div class="tw-relative" v-if="clients">
      <select class="fox-input--simple fox-input--simple-select tw-w-full" @change="selectClient($event.target.value)">
        <option selected value="">Rechnungsempfänger *</option>
        <option v-for="client in clients" :key="client.uuid" :value="client.uuid">
          {{ client.name }}
        </option>
      </select>

      <div class="tw-absolute tw-inset-y-0 tw-right-1 tw-flex tw-items-center tw-pointer-events-none">
        <v-icon>mdi-menu-down</v-icon>
      </div>
    </div>
    <label class="fox-label--simple" v-else>
      Rechnungsempfänger <span class="fox-input__require-star">*</span>
    </label>
    <div>
      <input type="text"
        v-model="receiverLocal.company"
        class="fox-input--simple tw-w-full"
        :placeholder="placeholder.company"
        v-bind:class="classes.company"
      >
    </div>
    <div>
      <input type="text"
             v-model="receiverLocal.name"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.name"
             v-bind:class="classes.name"
      >
    </div>
    <div>
      <input type="text"
             v-model="receiverLocal.street"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.street"
             v-bind:class="classes.street"
      >
    </div>
    <div class="tw-flex tw-gap-2">
      <input type="text"
             v-model="receiverLocal.postalCode"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.postalCode"
             v-bind:class="classes.postalCode"
      >
      <input type="text"
             v-model="receiverLocal.city"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.city"
             v-bind:class="classes.city"
      >
    </div>
    <div>
      <input type="text"
        v-model="receiverLocal.country"
        class="fox-input--simple tw-w-full"
        :placeholder="placeholder.country"
        v-bind:class="classes.country"
      >
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    receiver: {
      type: Object
    },
    clients: {
      type: Array
    }
  },
  data: function () {
    return {
      receiverLocal: { ...this.receiver },
      placeholder: {
        company: 'Unternehmen / Rechtsform',
        name: 'Name',
        street: 'Straße und Hausnummer',
        postalCode: 'PLZ',
        city: 'Stadt',
        country: 'Land'
      }
    }
  },
  validations () {
    return {
      receiverLocal: {
        name: { required },
        street: { required },
        postalCode: { required },
        city: { required },
        country: { required }
      }
    }
  },
  computed: {
    classes: function () {
      return {
        name: {
          'fox-input--error': this.v$.receiverLocal.name.$error
        },
        street: {
          'fox-input--error': this.v$.receiverLocal.street.$error
        },
        postalCode: {
          'fox-input--error': this.v$.receiverLocal.postalCode.$error
        },
        city: {
          'fox-input--error': this.v$.receiverLocal.city.$error
        },
        country: {
          'fox-input--error': this.v$.receiverLocal.country.$error
        }
      }
    }
  },
  watch: {
    receiver: {
      handler(newVal) {
        this.receiverLocal = { ...newVal }
      },
      immediate: true,
      deep: true
    },

    receiverLocal: {
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.receiver)) {
          this.$emit('update', newVal)
        }
      },
      deep: true
    }
  },
  methods: {
    updateReceiver () {
      this.$emit('update', this.receiverLocal)
    },
    selectClient (uuid) {
      const client = this.clients.find(c => c.uuid === uuid)

      this.receiverLocal.company = client.company
      this.receiverLocal.name = client.name
      this.receiverLocal.street = client.address
      this.receiverLocal.postalCode = client.zipCode
      this.receiverLocal.city = client.city
      this.receiverLocal.country = client.country
      this.receiverLocal.uuid = client.uuid
      this.updateReceiver()
    }
  }
}
</script>
